export default __webpack_public_path__ + "static/media/The-adjoining-villages.25517590.jpg";